// Must match CUSTOM_FIELD_PREFIX in backend/agency_fields.py.
export const CUSTOM_FIELD_PREFIX = 'custom:';

// Column ids whose cells are rendered explicitly by AdminAgencies rather than
// by the generic field renderer. Everything outside this set is generic.
export const RICH_AGENCY_COLUMN_IDS = new Set([
  'companyName',
  'status',
  'tier',
  'location',
  'marketRegion',
  'programs',
  'owner',
  'contactMethod',
  'lastContactDate',
  'followupDate',
  'notes',
]);

export const MIN_COLUMN_WIDTH = 60;
export const MAX_COLUMN_WIDTH = 600;

// Cycled by the alignment button in edit mode. "auto" leaves each cell with the
// alignment it already had, so old saved layouts look unchanged.
export const COLUMN_ALIGNMENTS = ['auto', 'left', 'center', 'right'];

export const ALIGN_CLASSES = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

export function nextAlignment(current) {
  const index = COLUMN_ALIGNMENTS.indexOf(current || 'auto');
  return COLUMN_ALIGNMENTS[(index + 1) % COLUMN_ALIGNMENTS.length];
}

// localStorage key for which saved view this admin is currently looking at.
// The view definitions are shared; the selection is personal.
export const ACTIVE_VIEW_STORAGE_KEY = 'mcc.agencies.activeViewId';
